<template>
  <div class="account-container">
    <h3>
      {{ $t("accountDetail.hello") }} {{ owner.firstname }} {{ owner.lastname }}
    </h3>
    <a :href="'/owner'">{{ $t("accountDetail.backToHome") }}</a>
    <hr />
    <div class="alert alert-danger" role="alert" v-if="fetchError">
      {{ $t("accountDetail.fetchError") }}
    </div>
    <button
      class="btn btn-primary account-manage-sub-btn"
      v-if="owner.stripe_id"
      @click="manageSubscriptions"
    >
      <font-awesome-icon :icon="['fas', 'tasks']" />&nbsp;
      {{ $t("accountDetail.manageSubBtn") }}
    </button>
    <button
      class=" btn btn-primary account-show-invoices-btn"
      v-if="owner.stripe_id"
      @click="retrieveInvoices"
    >
      <font-awesome-icon :icon="['fas', 'file']" />&nbsp;
      {{ $t("accountDetail.showInvoicesBtn") }}
    </button>
    <div
      class="spinner-border doc-upload-spinner"
      role="status"
      v-if="isLoadingInvoices && !invoices.length"
    ></div>
    <button class="btn btn-light account-contact-btn" @click="contactUs">
      <font-awesome-icon :icon="['fas', 'envelope']" />&nbsp;
      {{ $t("accountDetail.contactBtn") }}
    </button>
    <div class="invoices" v-if="invoices.length">
      <hr />
      <div
        class="account-invoice-row"
        v-for="invoice in invoices"
        :key="invoice.id"
      >
        <h5>{{ $t("accountDetail.invoiceNumber") }} {{ invoice.number }}</h5>
        {{ $t("accountDetail.paidOn") }}
        {{ getPaymentDate(invoice.status_transitions.paid_at) }} -
        <b
          >{{ calculatePaidAmount(invoice.amount_paid) }}
          {{ invoice.currency }}</b
        >
        <br />
        <br />
        <button
          class=" btn btn-primary account-show-invoices-btn"
          @click="goToInvoiceDetails(invoice.hosted_invoice_url)"
        >
          {{ $t("accountDetail.seeInvoiceDetails") }}
        </button>
        <hr />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { OWNER_CONTACT_EMAIL } from "@/const";
import UtilsService from "@/services/UtilsService";
const utilsService = new UtilsService();
import OwnerService from "@/services/OwnerService";
const ownerService = new OwnerService();
import router from "@/router";

export default defineComponent({
  name: "Login",
  props: {},
  setup(props) {
    console.log("account setup");

    const owner = ref({ uid: null, stripe_id: null });
    const fetchError = ref(false);

    onMounted(async () => {
      console.log("mounted");

      const LSOwner = localStorage.getItem("owner");
      // send user back to login if LS is empty
      if (LSOwner == null) {
        router.replace("/login");
        return;
      }
      const parsedOwner = JSON.parse(LSOwner);

      const fetchedOwner = await ownerService.getOwnerByid(parsedOwner.uid);
      console.log("fetchedOwner", fetchedOwner);

      if (!fetchedOwner.exists) {
        fetchError.value = true;
        return;
      }

      owner.value = fetchedOwner.data.owner;

      console.log("OWNER", owner);
    });
    return {
      owner,
      fetchError,
    };
  },
  methods: {
    /**
     * Retrieve the user's invoice
     */
    async retrieveInvoices() {
      this.isLoadingInvoices = true;
      console.log("retrieveInvoices");
      this.invoices = await ownerService.getOwnersInvoices(
        this.owner.uid,
        this.owner.stripe_id
      );
      this.isLoadingInvoices = false;
    },
    // open invoice detils on Stripe website
    async goToInvoiceDetails(invoiceUrl: string) {
      console.log("goToInvoiceDetails");
      window.open(invoiceUrl, "_blank");
      // avoir
    },
    async manageSubscriptions() {
      ownerService.goToStripePortal(this.owner.stripe_id);
      // open portal
    },
    contactUs() {
      window.location.href = `mailto:${OWNER_CONTACT_EMAIL}`;
    },
    // get the amount paid
    calculatePaidAmount(amount: number) {
      return amount / 100;
    },
    // get the payment date
    getPaymentDate(timestamp: number) {
      return utilsService.getDateFromTimestamp(timestamp * 1000, false, true);
    },
  },
  data() {
    return {
      invoices: [],
      isLoadingInvoices: false,
    };
  },
});
</script>
